import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [studentId, setStudentId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!studentId || !phoneNumber) {
      alert("Please provide your student ID and phone number.");
      return;
    }

    setLoading(true);
    const apiUrl = `https://www.api.cosmopolitan.edu.ng/index.php?studentid=${studentId}&phonenumber=${phoneNumber}`;
    
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();

      console.log("Fetched Data:", data);
      setLoading(false);

      if (data && data.length > 0) {
        navigate("/StudentDetails", { state: { data: data[0] } });
      } else {
        alert("Login Failed: Invalid student ID or phone number");
      }
    } catch (error) {
      setLoading(false);
      alert(error.message.includes("Network") ? "Network error. Please check your internet connection." : "An unexpected error occurred.");
    }
  };

  return (
    <div style={styles.container}>
      <img src="/cosmologo.png" alt="Logo" style={styles.image} />
      <h1 style={styles.title}>WELCOME</h1>
      <p style={styles.subtitle}>Please provide the fields below to activate your account</p>
     
      <div style={styles.form}>
      <div style={styles.passwordContainer}>
        <input
          type="text"
          placeholder="Student ID"
          value={studentId}
          onChange={(e) => setStudentId(e.target.value)}
          style={styles.input}
        />
      </div>

      <div style={styles.passwordContainer}>
        <input
          type="tel"
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          style={styles.input}
        />
      </div>
      <button onClick={handleLogin} style={styles.loginButton}>
        {loading ? "Loading..." : "Proceed"}
      </button>

      </div>

      <p style={styles.activateText} onClick={() => navigate("/AuthLogin")}>
        Already have an accounted activated? Click Here!
      </p>

    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f4f6f8",
    padding: "20px",
    textAlign: "center",
  },
  image: {
    width: "120px",
    height: "120px",
    marginBottom: "20px",
    borderRadius: "60px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#333",
    FontFace: "sans-serif"
  },
  subtitle: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "30px",
  },
  form: {
    width: "100%",
    maxWidth: "400px",
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  },
  input: {
    width: "100%",
    padding: "15px",
    marginBottom: "10px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    fontSize: "16px",
    outline: "none",
  },
  passwordContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  loginButton: {
    backgroundColor: "#013a64",
    padding: "15px",
    borderRadius: "10px",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
    border: "none",
    width: "100%",
    marginTop: "10px",
  },
  activateText: {
    marginTop: "20px",
    color: "#007bff",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export default Login;
